import React from 'react';
import TextTranslate from '../../Components/TextTranslate/TextTranslate';

const PersonalDetails = ({guest, index, ...props}) => {

    return (
        <div className="guest-personal-details">
            <div className="row">
                <div className="col-lg-4 col-12">
                    <label>
                        <TextTranslate name="user-full-name" fallback="Full Name" textOnly/>
                    </label>
                </div>
                <div className="col-lg-8 col-12">
                    <p>{guest.first_name} {guest.last_name}</p>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-lg-4 col-12">
                    <label><TextTranslate name="user-email-address" fallback="Email Address"/></label>
                </div>
                <div className="col-lg-8 col-12">
                    <p>{guest.email}</p>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-lg-4 col-12">
                    <label><TextTranslate name="user-phone-number" fallback="Phone Number"/></label>
                </div>
                <div className="col-lg-8 col-12">
                    <p>{guest.phone}</p>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-lg-4 col-12">
                    <label><TextTranslate name="user-company" fallback="Company"/></label>
                </div>
                <div className="col-lg-8 col-12">
                    <p>{guest.company}</p>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="col-lg-4 col-12">
                    <label><TextTranslate name="user-job-title" fallback="Job Title"/></label>
                </div>
                <div className="col-lg-8 col-12">
                    <p>{guest.job_title}</p>
                </div>
            </div>
        </div>
    )
}


export default PersonalDetails;
